import {cn} from 'platform/shared-tw';

import {PartSvg, type PartMode} from '../shared/PartSvg';
import {partFill, partStroke, type DiagramVariant} from '../shared/partVariants';

interface RearSeatsProps {
  readonly mode?: PartMode;
  readonly variant?: DiagramVariant;
  readonly onClick?: () => void;
}

export function RearSeats(props: RearSeatsProps) {
  return (
    <PartSvg
      mode={props.mode}
      onClick={props.onClick}
      label="Rear Seats"
      width={224}
      height={358}
      viewBox="0 0 224 358"
      position={{top: 72, right: 295}}
    >
      <path
        d="M223 322.758C223 350.574 178.317 355.057 161.443 348.103L161 348.067C155.077 353.132 130.069 363.386 109.684 351.433L109 351C101.458 354.563 79.4317 357 54.6598 357C4.84678 357 1 321 1 302V278V254C1 235 4.84678 199 54.6598 199C79.4317 199 101.458 201.438 109 205L109.684 204.568C130.069 192.614 155.077 202.869 161 207.934L161.443 207.898C178.317 200.944 223 205.426 223 233.242V278V322.758Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      <path
        d="M161 207.934C155.077 202.869 130.069 192.614 109.684 204.568C106.229 206.594 108.697 216.434 111.658 220.775C114.619 225.116 121.529 230.399 126.958 232.425C132.387 234.45 161 233.943 161 233.943"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M12 216C21 224 30 232 55 232C80.6 232 82 232 84 232C91 232 109 230 112 221"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M161 208C170 210 181 212.492 181 222C181 231.508 181 243 181 246"
        stroke="currentColor"
        strokeDasharray="3 3"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M210 245C210 242 210 233.508 210 224C210 211.877 195 207 195 207"
        stroke="currentColor"
        strokeDasharray="3 3"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M165 270.633C167.862 267.818 172.679 259.684 189.984 259.684C198.956 259.684 204.4 259.684 208.646 259.684C212.893 259.684 215.997 263.288 215.997 266.013"
        stroke="currentColor"
        strokeDasharray="3 3"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M165 296V278V260C165 255 171.295 245 191 245H204C208 245 216 245 216 251V278V305C216 311 208 311 204 311H191C171.295 311 165 301 165 296Z"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M51 324L46 319C44 317 43 315 43 312V278V244C43 241 44 239 46 237L51 232"
        stroke="currentColor"
        strokeDasharray="3 3"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M161 348.067C155.077 353.132 130.069 363.386 109.684 351.433C106.229 349.407 108.697 339.567 111.658 335.225C114.619 330.884 121.529 325.602 126.958 323.576C132.387 321.55 161 322 161 322"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M12 340C21 332 30 324 55 324C80.6 324 82 324 84 324C91 324 109 326 112 335"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M161 348C170 346 181 343.508 181 334C181 324.493 181 313 181 310"
        stroke="currentColor"
        strokeDasharray="3 3"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M210 311C210 314 210 322.493 210 332C210 344.123 195 349 195 349"
        stroke="currentColor"
        strokeDasharray="3 3"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M109 351C101.458 354.563 79.4317 357 54.6598 357C4.84678 357 1 321 1 302V278V254C1 235 4.84678 199 54.6598 199C79.4317 199 101.458 201.438 109 205"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M168.993 303.385C164.074 306.561 154.495 337.175 161.443 348.103C178.317 355.057 223 350.574 223 322.758C223 301.299 223 281.312 223 278C223 274.689 223 254.701 223 233.242C223 205.426 178.317 200.944 161.443 207.898C154.495 218.826 164.074 249.44 168.993 252.616"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M130 323C128 322 124 319.01 124 316C124 312.8 124 278 124 278C124 278 124 243.2 124 240C124 236.991 128 234 130 233"
        stroke="currentColor"
        strokeDasharray="3 3"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M165 285.367C167.862 288.183 172.679 296.317 189.984 296.317C198.956 296.317 204.4 296.317 208.646 296.317C212.893 296.317 215.997 292.713 215.997 289.988"
        stroke="currentColor"
        strokeDasharray="3 3"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M165 278H43"
        stroke="currentColor"
        strokeDasharray="3 3"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M223 124.758C223 152.574 178.317 157.057 161.443 150.103L161 150.067C155.077 155.132 130.069 165.386 109.684 153.433L109 153C101.458 156.563 79.4317 159 54.6598 159C4.84678 159 1 123 1 104V80.0005V55.9999C1 36.9999 4.84678 1 54.6598 1C79.4317 1 101.458 3.43769 109 6.99994L109.684 6.56774C130.069 -5.38606 155.077 4.86885 161 9.93362L161.443 9.89785C178.317 2.9437 223 7.42613 223 35.2425V80.0005V124.758Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      <path
        d="M161 9.93362C155.077 4.86885 130.069 -5.38606 109.684 6.56774C106.229 8.59363 108.697 18.4338 111.658 22.7751C114.619 27.1163 121.529 32.3987 126.958 34.4246C132.387 36.4505 161 35.9435 161 35.9435"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M12 18.0003C21 26.0003 30 34.0003 55 34.0003C80.6 34.0003 82 34.0003 84 34.0003C91 34.0003 109 32 112 23"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M161 9.99994C170 11.9999 181 14.492 181 23.9999C181 33.5078 181 44.9998 181 47.9999"
        stroke="currentColor"
        strokeDasharray="3 3"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M210 46.9999C210 43.9998 210 35.5078 210 25.9999C210 13.8774 195 8.99994 195 8.99994"
        stroke="currentColor"
        strokeDasharray="3 3"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M165 72.6331C167.862 69.8177 172.679 61.6839 189.984 61.6839C198.956 61.6839 204.4 61.6839 208.646 61.6839C212.893 61.6839 215.997 65.2878 215.997 68.0127"
        stroke="currentColor"
        strokeDasharray="3 3"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M165 98.0003V80.0003V62.0001C165 57.0001 171.295 47.0001 191 47.0001H204C208 47.0001 216 47.0001 216 53.0001V80.0003V107C216 113 208 113 204 113H191C171.295 113 165 103 165 98.0003Z"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M51 126L46 121C44 119 43 117 43 114V79.9999V46.0003C43 42.9999 44 40.9999 46 38.9999L51 33.9999"
        stroke="currentColor"
        strokeDasharray="3 3"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M161 150.067C155.077 155.132 130.069 165.386 109.684 153.433C106.229 151.407 108.697 141.567 111.658 137.225C114.619 132.884 121.529 127.602 126.958 125.576C132.387 123.55 161 124 161 124"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M12 142C21 134 30 126 55 126C80.6 126 82 126 84 126C91 126 109 128 112 137"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M161 150C170 148 181 145.508 181 136C181 126.493 181 115 181 112"
        stroke="currentColor"
        strokeDasharray="3 3"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M210 113C210 116 210 124.493 210 134C210 146.123 195 151 195 151"
        stroke="currentColor"
        strokeDasharray="3 3"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M109 153C101.458 156.563 79.4317 159 54.6598 159C4.84678 159 1 123 1 104V80.0005V55.9999C1 36.9999 4.84678 1 54.6598 1C79.4317 1 101.458 3.43769 109 6.99994"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M168.993 105.385C164.074 108.561 154.495 139.175 161.443 150.103C178.317 157.057 223 152.574 223 124.758C223 103.3 223 83.312 223 80.0005C223 76.689 223 56.7009 223 35.2425C223 7.42613 178.317 2.9437 161.443 9.89785C154.495 20.8259 164.074 51.4397 168.993 54.6158"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M130 125C128 124 124 121.01 124 118C124 114.8 124 79.9999 124 79.9999C124 79.9999 124 45.1999 124 41.9999C124 38.9906 128 35.9999 130 34.9999"
        stroke="currentColor"
        strokeDasharray="3 3"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M165 87.3675C167.862 90.183 172.679 98.3167 189.984 98.3167C198.956 98.3167 204.4 98.3167 208.646 98.3167C212.893 98.3167 215.997 94.7129 215.997 91.988"
        stroke="currentColor"
        strokeDasharray="3 3"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M165 80.0004H43"
        stroke="currentColor"
        strokeDasharray="3 3"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M1 158.5L1.00011 179L1 199.5C1 208.872 7.49989 209 16 209H199C219.5 209 222 208.872 222 179C222 149.128 219.5 149 199 149H16C7.49989 149 1 149.128 1 158.5Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      <path
        d="M1 158.5L1.00011 179L1 199.5C1 208.872 7.49989 209 16 209H199C219.5 209 222 208.872 222 179C222 149.128 219.5 149 199 149H16C7.49989 149 1 149.128 1 158.5Z"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      <rect
        x="30"
        y="174"
        width="3"
        height="10"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <rect
        x="10"
        y="175"
        width="8"
        height="8"
        rx="4"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <rect
        x="9"
        y="161"
        width="3"
        height="8"
        rx="1.5"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <rect
        x="9"
        y="189"
        width="3"
        height="8"
        rx="1.5"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <rect
        x="15"
        y="161"
        width="3"
        height="8"
        rx="1.5"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <rect
        x="15"
        y="189"
        width="3"
        height="8"
        rx="1.5"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M44 149V209"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M157 149V209"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M164 174.633C166.862 171.818 171.679 163.684 188.984 163.684C197.956 163.684 203.4 163.684 207.646 163.684C211.893 163.684 214.997 167.288 214.997 170.013"
        stroke="currentColor"
        strokeDasharray="3 3"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M164 186V179V172C164 167 170.295 157 190 157H203C207 157 215 157 215 163V179V195C215 201 207 201 203 201H190C170.295 201 164 191 164 186Z"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M164 183.368C166.862 186.183 171.679 194.317 188.984 194.317C197.956 194.317 203.4 194.317 207.646 194.317C211.893 194.317 214.997 190.713 214.997 187.988"
        stroke="currentColor"
        strokeDasharray="3 3"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M44 197H28C26.8954 197 26 196.105 26 195V179V163C26 161.895 26.8954 161 28 161H44"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M105.5 149V209"
        stroke="currentColor"
        strokeDasharray="4 4"
        className={partStroke({variant: props.variant})}
      />
    </PartSvg>
  );
}
